import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/about/impact/pageContext';

export const ImpactErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Impact page (error: ${error})`);
};
